<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  (onHide)="handleDialogHide()"
  header="Vi vill gärna veta vad du tycker"
>
  <div style="max-width: 400px">
    <p>
      Hjälp oss att förbättra {{ appName }} genom att dela med dig av din
      upplevelse.
    </p>
    <p class="p-mr-2 p-text-bold p-mb-1">Hur nöjd är du med {{ appName }}?</p>
    <p-rating
      inputId="feedback-rating"
      [(ngModel)]="rating"
      [cancel]="false"
    ></p-rating>
    <div class="p-my-2">
      <p>Har du några tankar eller önskemål?</p>
      <textarea
        pInputTextarea
        placeholder="Berätta gärna vad vi kan förbättra..."
        [(ngModel)]="comment"
        rows="4"
        [autoResize]="true"
        class="p-text-normal"
      ></textarea>
    </div>
    <div class="p-d-flex p-jc-end">
      <button
        type="button"
        pButton
        label="Skicka"
        class="p-button-primary-hyperion"
        (click)="onSubmit()"
        [disabled]="!rating"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Tack för din feedback!"
  [(visible)]="thankYouVisible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
>
  <div style="max-width: 400px">
    <p>
      Tack för att du tog dig tid att ge oss feedback. Din åsikt är viktig för
      oss och hjälper oss att förbättra {{ appName }}.
    </p>
  </div>
</p-dialog>
